import { Country } from "@shared/api"
import { FormattedCountry } from "@shared/models"
import i18next from "i18next"

export const formatCountries = (countries: Country[]): FormattedCountry[] =>
	countries.map(country => ({
		name: i18next.t(`shared:country.${country.countryCode}`, {
			defaultValue: country.countryName,
		}),
		countryCode: country.countryCode,
		locales: country.locales.map(locale => ({
			code: locale.code,
			name: locale.name,
		})),
	}))
